module.exports = __webpack_public_path__ + "static/media/login-background.e3c6a756.jpg";